const YouTubeIcon = (): JSX.Element => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 28 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M27.415 2.99277C27.0929 1.81477 26.1442 0.887039 24.9394 0.572194C22.756 0 14 0 14 0C14 0 5.24417 0 3.06064 0.572194C1.85576 0.887039 0.906821 1.81477 0.585019 2.99277C0 5.12795 0 9.58297 0 9.58297C0 9.58297 0 14.0378 0.585019 16.1732C0.906821 17.3513 1.85576 18.2788 3.06052 18.594C5.24405 19.1659 13.9999 19.1659 13.9999 19.1659C13.9999 19.1659 22.7558 19.1659 24.9392 18.594C26.1441 18.2789 27.0928 17.3513 27.4149 16.1733C28 14.0379 28 9.58309 28 9.58309C28 9.58309 28 5.12807 27.4149 2.99289"
			fill="#FF0000"
		/>
		<path
			d="M11.1357 13.6276L18.4539 9.58303L11.1357 5.53802V13.6276Z"
			fill="white"
		/>
	</svg>
)

export default YouTubeIcon
